/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IImageTests } from 'app/shared/model/image-tests.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IRadiologyPricing {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  taxCode?: string;
  price?: number;
  discount?: number;
  addedByType?: keyof typeof AddedByType | null;
  addedByID?: string;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string;
  multiplierApplied?: boolean;
  startDate?: number;
  endDate?: number | null;
  suspended?: boolean;
  draft?: boolean;
  scheme?: IPaymentScheme | null;
  hospital?: IHospital | null;
  diagLab?: IDiagLab | null;
  imageTests?: IImageTests | null;
}

export const defaultValue: Readonly<IRadiologyPricing> = {
  active: false,
  multiplierApplied: false,
  suspended: false,
  draft: false,
};
